import React from 'react';
import { Layout } from '@/layout/Layout';
import { Trans, useTranslation } from 'react-i18next';

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Layout hideHeaderButtons>
      <main className="privacy-page">
        <article className="privacy-card">
          <header className="privacy-header">
            <p className="privacy-kicker">LensSift</p>
            <h1>{t('privacy-title')}</h1>
            <p className="privacy-summary">{t('privacy-summary')}</p>
            <div className="privacy-badge">{t('privacy-no-upload')}</div>
          </header>

          <section className="privacy-section">
            <h2>1. {t('privacy-h1')}</h2>
            <p>{t('privacy-p1')}</p>
          </section>

          <section className="privacy-section">
            <h2>2. {t('privacy-h2')}</h2>
            <p>{t('privacy-p2')}</p>
          </section>

          <section className="privacy-section">
            <h2>3. {t('privacy-h3')}</h2>
            <p>{t('privacy-p3')}</p>
          </section>

          <section className="privacy-section">
            <h2>4. {t('privacy-h4')}</h2>
            <p>{t('privacy-p4')}</p>
          </section>

          <section className="privacy-section">
            <h2>5. {t('privacy-h5')}</h2>
            <p>
              <Trans i18nKey="privacy-p5" components={{ 1: <a href="mailto:info@lenssift.com" /> }} />
            </p>
          </section>
        </article>
      </main>
    </Layout>
  );
};

export default PrivacyPolicy;
